/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Private_Chats_Note_See_AllInputs */



/**
* | output |
* | --- |
* | "Chats in this project are private, but you may see everyone's chats here, with their attached files and AI-created documents — other members' chats read-only..." |
*
* @param {Project_Private_Chats_Note_See_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_private_chats_note_see_all = /** @type {((inputs?: Project_Private_Chats_Note_See_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Private_Chats_Note_See_AllInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Chats in diesem Projekt sind privat, Sie dürfen hier aber die Chats aller Mitglieder samt angehängten Dateien und KI-erstellten Dokumenten sehen – die Chats anderer Mitglieder nur lesend. Mitglieder ohne diese Berechtigung sehen nur ihre eigenen.")
	return /** @type {LocalizedString} */ ("Chats in this project are private, but you may see everyone's chats here, with their attached files and AI-created documents — other members' chats read-only. Members without this permission only see their own.")
});